import React from "react";
import { useHydrateOnboardingProfile } from "./useHydrateOnboardingProfile";
import { bootStep } from "./diag";

export default function AuthBootstrap() {
  if (typeof window !== "undefined") bootStep("auth_bootstrap"); // DIAG
  useHydrateOnboardingProfile();

  return null;
}
